export default {
  _isNullorEmpty (value) {
    if (typeof value == "undefined" || value == null || value == "" || value == "-1" || value == "[]") {
      this.evaluation = "不能为空";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _limitMaxLength (value, maxValue) {
    if (value.replace(/[\u0391-\uFFE5]/g, "aa").length > new Number(maxValue)) {
      this.evaluation = "大于最大长度" + maxValue;
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _limitMinLength (value, minValue) {
    if (value.replace(/[\u0391-\uFFE5]/g, "aa").length < new Number(minValue)) {
      this.evaluation = "小于最小长度" + minValue;
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkEmail (email) {
    let pattern = /^[a-zA-Z0-9_\-]{1,}@[a-zA-Z0-9_\-]{1,}\.[a-zA-Z0-9_\-.]{1,}$/;
    if (!pattern.exec(email)) {
      this.evaluation = "邮箱格式错误";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkPhone (phone) {
    let pattern = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!pattern.test(phone)) {
      this.evaluation = "手机号码格式错误";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkPersonId (code) {
    //身份证号合法性验证
    //支持15位和18位身份证号
    //支持地址编码、出生日期、校验位验证
    let city = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
        this.evaluation = "身份证格式错误";
        return false;
    } else if (!city[code.substr(0,2)]) {
        this.evaluation = "身份证格式错误";
        return false;
    } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            //校验位
            var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            if (parity[sum % 11] != code[17].toUpperCase()) {
                this.evaluation = "身份证格式错误";
                return false;
            }
        }
    }
    this.evaluation = "";
    return true;
  },
  _checkUnModify () {
    this.evaluation = "";
    return true;
  },
  _checkUppercase (value) {
    let reg = /^[A-Z]+$/;
    if (!reg.test(value)) {
      this.evaluation = "仅限大写英文字母";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkNumber (value) {
    let reg = /^[0-9]*$/;
    if (!reg.test(value)) {
      this.evaluation = "只能填写数字";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkFileSize (file, limitSize) {
    let fileSize = file.size / 1024 / 1024;
    if (fileSize > limitSize) {
      this.evaluation = '文件大小超出最大限制(文件上限' + Math.round(limitSize * 1024) + 'KB)';
      return false;
    }
    this.evaluation = '';
    return true;
  },
  _checkFileType (file, type) {
	  let fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toUpperCase();
    let fileTypeArr = type;
    if (!Array.isArray(fileTypeArr)) {
      fileTypeArr = fileTypeArr.split(",");
      fileTypeArr = fileTypeArr.map(item => {
        return item.toUpperCase();
      });
    }
    if (fileTypeArr.indexOf(fileType) == -1) {
      this.evaluation = "文件类型错误(支持" + fileTypeArr.join("、") + ")";
      return false;
    }
    this.evaluation = "";
    return true;
  },
  _checkFileCount () {
    this.evaluation = "";
    return true;
  },
  _checkSocialCreditCode (code) {
    let reg = /^[0-9A-Z]+$/;
    let errorTip = "不是有效的统一社会信用代码";
    //18位校验及大写校验
    if ((code.length != 18) || (reg.test(code) == false)) {
      this.evaluation = errorTip;
      return false;
    } else {
      let Ancode; // 统一社会信用代码的每一个值
      let Ancodevalue;  // 统一社会信用代码每一个值的权重
      let total = 0;
      let weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]; // 加权因子
      let str = "0123456789ABCDEFGHJKLMNPQRTUWXY";
      // 不用I、O、S、V、Z
      for (let i = 0; i < code.length - 1; i++) {
        Ancode = code.substring(i, i + 1);
        Ancodevalue = str.indexOf(Ancode);
        total = total + Ancodevalue * weightedfactors[i];
        //权重与加权因子相乘之和
      }
      let logiccheckcode = 31 - total % 31;
      if (logiccheckcode == 31) {
        logiccheckcode = 0;
      }
      let Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
      let Array_Str = Str.split(',');
      logiccheckcode = Array_Str[logiccheckcode];
      let checkcode = code.substring(17, 18);
      if (logiccheckcode != checkcode) {
        this.evaluation = errorTip;
        return false;
      }
      this.evaluation = "";
      return true;
    }
  },
  _checkRegex(value, reg) {
    let newReg = new RegExp(reg);
    if (!newReg.test(value)) {
      this.evaluation = '不符合规则';
      return false;
    }
    this.evaluation = '';
    return true;
  }
};



// WEBPACK FOOTER //
// ../src/assets/js/validate.js